
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Schnarchen an sich ist keine Krankheit. Wenn aber zusätzlich nachts der Atem aussetzt, kann es gefährlich werden. In diesen Fällen spricht man von einer Schlafapnoe. Auslöser der Krankheit ist in der Regel ein zu enger oder instabiler Atemweg zwischen Gaumen und Kehlkopf. Als Symptom tritt meist ein lautes und unregelmässiges Schnarchen auf, welches von Atempausen unterbrochen wird,`}<M mdxType="M">{`die jeweils mehrere Sekunden dauern. Pro Nacht kann sich das über hundert Mal wiederholen,`}</M>{` vor allem dann, wenn der Schläfer auf dem Rücken liegt und seine Rachenmuskulatur entspannt ist. Zu den weiteren Symptomen zählen Tagesmüdigkeit mit Konzentrationsmangel und Kopfschmerzen. `}<br /></p>
    <M mdxType="M">Rund sechs Prozent der arbeitstätigen Bevölkerung sind von Schlafapnoe betroffen, Männer doppelt so häufig wie Frauen.</M> Der Prozentsatz für ältere Menschen liegt ebenfalls höher. Leidet ein Mensch über Jahre an unbehandelter Schlafapnoe, treten häufig schwere gesundheitliche Störungen auf. Gefährlich ist die Krankheit vor allem darum, weil auf diese Weise die Tiefe des Schlafs und dessen Qualität vermindert wird, wodurch er weniger erholsam ist. In der Folge kann es unter anderem zu Tagesschläfrigkeit, Stoffwechsel- und Kreislaufproblemen kommen. Ausserdem muss das Herz durch den Sauerstoffmangel und den entstehenden Unterdruck im Brustraum mehr leisten, der Blutdruck steigt und das Risiko für Herzinfarkt und Schlaganfall ebenso. 
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;